import { motion } from 'framer-motion';
import { FiDownloadCloud } from 'react-icons/fi';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './SetupDownload.scss';
import fnc from '../mymod/commFunction';




const SetupDownload = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';


    const [firstCall, setFirstCall] = useState('');
    const [showInstallHelpModal, setShowInstallHelpModal] = useState(false);
    const installHelpPath = '/manual/embed/MANUAL_1776825908933_1776825991591';
 
    const setupDownloadUrl_msi = 'https://mathautogen.s3.ap-northeast-2.amazonaws.com/public/setup_%EB%A7%A4%EC%93%B0%ED%85%8C%EC%9D%BC%EB%9F%AC_v2.msi';
    const setupDownloadUrl_zip = 'https://mathautogen.s3.ap-northeast-2.amazonaws.com/public/setup_%EB%A7%A4%EC%93%B0%ED%85%8C%EC%9D%BC%EB%9F%AC_v2.zip';
   
    useEffect(() => {
        fncSelect_firstCall('firstCall');
    }, []);

    function fncSelect_firstCall(title) {
        fnc.sendAxios('/homePageRoutes/selectSetting', { title }, (res) => {
            if (res && Array.isArray(res)) {
            const settingData = res[0];
            setFirstCall(settingData.value);

            } else {
            alert('데이터를 불러오는 데 실패했습니다.');
            }
        });

    }

    function handleDownloadClick() {
        fnc.sendAxios('/homePageRoutes/increaseViewCount', { pageKey: 'setup_download' }, () => {});
        if (typeof window.gtag_report_conversion === 'function') {
            window.gtag_report_conversion();
        }
    }


    //-------------------------------------------------------------
    return (
        <section className={`setup-download ${isHomePage ? 'setup-download--home' : ''}`.trim()} id="setup-download">
            <div className="container">
                <motion.article
                    className="setup-panel"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.25 }}
                    transition={{ duration: 0.48 }}
                >
                    <div className="setup-content">
                        <div className="setup-badges">
                            <p className="setup-eyebrow">시즌1</p>
                            <span className="setup-beta">시즌2 변환 고도화 업데이트</span>
                            <span className="setup-beta">시즌3 나만의 문제은행 구축</span>
                        </div>
                        <h2 className="setup-title">매쓰테일러 설치파일 다운로드</h2>
                        <p className="setup-description">
                            시즌2 업데이트를 통해 낙서(필기)된 PDF 활용 기능이 추가되었습니다. 더욱 정교한 작업 환경을 위해 꾸준히 업그레이드하고 있습니다.
                        </p>

                        <div className="setup-meta" aria-label="설치 정보">
                            <span>Windows 10+</span>
                            <span>최신 버전 제공</span>
                            <span>즉시 설치 가능</span>
                        </div>
                    </div>

                    <div className="setup-cta">
                        <p className='setup-signup-notice'>설치파일에서도 회원가입하실 수 있습니다.</p>
                        <p className='firstCall'>최초 가입시 PDF {firstCall} 페이지 변환 무료 충전</p>
                        <div className="setup-download-actions">
                            <a
                                href={setupDownloadUrl_msi}
                                download
                                className="setup-download-btn setup-download-btn--msi"
                                onClick={handleDownloadClick}
                            >
                                <FiDownloadCloud size={20} />
                                <span className="setup-download-btn-copy">
                                    <strong>설치파일 다운로드 (MSI)</strong>
                                </span>
                            </a>
                            <a
                                href={setupDownloadUrl_zip}
                                download
                                className="setup-download-btn setup-download-btn--zip"
                                onClick={handleDownloadClick}
                            >
                                <FiDownloadCloud size={20} />
                                <span className="setup-download-btn-copy">
                                    <strong>설치파일 다운로드 (ZIP)</strong>
                                </span>
                            </a>
                        </div>
                        <button
                            type="button"
                            className="setup-troubleshoot-btn"
                            onClick={() => setShowInstallHelpModal(true)}
                        >
                            설치 오류 해결 방법
                        </button>
                        {/* <p className="setup-help">
                            다운로드 후 압축을 해제한 뒤 실행 파일로 설치를 진행하세요.
                        </p> */}
                        <p className="setup-contact">
                            문의 : <a href="tel:01088906672">010-8890-6672</a>
                        </p>
                        <p className="setup-bank-inline">홈페이지 로그인 후 충전하기 메뉴에서 토스페이먼츠로 바로 충전하실 수 있습니다.</p>
                    </div>
                </motion.article>
            </div>

            {showInstallHelpModal && (
                <div
                    className="setup-help-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-label="설치 오류 해결 방법"
                    onClick={() => setShowInstallHelpModal(false)}
                >
                    <div className="setup-help-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="setup-help-modal-header">
                            <h3>설치 오류 해결 방법</h3>
                            <button
                                type="button"
                                className="setup-help-modal-close"
                                onClick={() => setShowInstallHelpModal(false)}
                                aria-label="닫기"
                            >
                                ×
                            </button>
                        </div>

                        <div className="setup-help-modal-body">
                            <iframe
                                src={installHelpPath}
                                title="설치 오류 해결 방법"
                                loading="lazy"
                            />
                        </div>

                        <div className="setup-help-modal-footer">
                            <a href={installHelpPath} target="_blank" rel="noreferrer">
                                새 창으로 열기
                            </a>
                            <button type="button" onClick={() => setShowInstallHelpModal(false)}>
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default SetupDownload;
